import React from 'react'
import "./footer.css";
const Footer = () => {
  return (
    <>
        <div className='footer' style={{marginTop: 400}}>
            <div className='foterdata'>
                    © Copyright by SR3 2025
            </div>  
        </div>
    </>
  )
}

export default Footer